import React, { useEffect } from 'react';
import './LoginPage.scss';
import { useSelector, useDispatch } from 'react-redux';
import Loading from '../components/Placeholders/Loading';
import { useNavigate } from 'react-router-dom';
import { HOME_PAGE } from '../constants/routes';
import { searchActions } from 'actions/search';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {userName} = useSelector((state) => state?.userTypeReducer?.userType?.data) || {};
  const isLoading = useSelector((state) => state?.userTypeReducer?.loading);


  useEffect(() => {
    dispatch(searchActions.getSearchValues('',{pageNumber:1, pageSize:10}));
    if (userName) {
      navigate(HOME_PAGE);
    }
  }, [userName]);

  return <>{isLoading && <Loading />}</>;
};

export default LoginPage;
